import PropTypes from "prop-types";

const MultiStoreOverrideStatus = props => {
  return (
    props.stages.filter(x => x.stage.description === props.currentStage)
      .length +
    "/" +
    props.stages.length +
    " " +
    props.currentStage
  );
};

MultiStoreOverrideStatus.propTypes = {
  stages: PropTypes.arrayOf(
    PropTypes.shape({
      storeId: PropTypes.string,
      stage: PropTypes.shape({
        name: PropTypes.string,
        description: PropTypes.string
      })
    })
  ),
  currentStage: PropTypes.string
};

export default MultiStoreOverrideStatus;
